<template>
  <div>
    <div
      v-if="data.activeUntil > 0"
      class="inactive-info-text"
    >
      Tato vlastnost je deaktivovaná
    </div>
    <div class="asd-form">
      <label for="data-type">Datovy typ</label>
      <Multiselect
        id="data-type"
        v-model="data.type"
        :max="1"
        label="label"
        trackBy="id"
        valueByPath="id"
        :options="dataTypes"
        :returnAsSingle="true"
      >
      </Multiselect>

      <div v-if="data.type">
        <label class="required">{{ $t('common.name') }}</label>
        <input v-model="data.name"
               type="text"
               class="asd-input"
               required="required"
               pattern=".+"
        >

        <ul class="nav nav-tabs property-settings">
          <li class="nav-item">
            <a class="nav-link"
               :class="{'active': activeTab == 'auto-prefill'}"
               href="#"
               @click="activeTab = 'auto-prefill'"
            >Automatické předvyplnění vlastností</a>
          </li>

          <li class="nav-item">
            <a class="nav-link"
               :class="{'active': activeTab == 'show-in-table'}"
               href="#"
               @click="activeTab = 'show-in-table'"
            >Nastavení zobrazování</a>
          </li>

          <li v-if="data.type === 'STATIC_STRING'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'autocomplete'}"
               href="#"
               @click="activeTab = 'autocomplete'"
            >Našeptávač</a>
          </li>

          <li v-if="data.type === 'STATIC_STRING'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'validation'}"
               href="#"
               @click="activeTab = 'validation'"
            >Validace</a>
          </li>

          <li v-if="data.type === 'STATIC_STRING'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'default-value'}"
               href="#"
               @click="activeTab = 'default-value'"
            >Automatické doplnění hodnot</a>
          </li>

          <li v-if="data.type === 'ENUM'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'enum'}"
               href="#"
               @click="activeTab = 'enum'"
            >Výběr z číselníku</a>
          </li>

          <li v-if="data.type === 'FLEXIBEE'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'flexibee'}"
               href="#"
               @click="activeTab = 'flexibee'"
            >Flexibee</a>
          </li>

          <li v-if="data.type === 'LINK_PERSON_RESOURCE' || data.type === 'LINK' || data.type === 'ENUM'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'multiple'}"
               href="#"
               @click="activeTab = 'multiple'"
            >Počet položek</a>
          </li>

          <li v-if="data.type === 'LINK'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'link'}"
               href="#"
               @click="activeTab = 'link'"
            >Typ linku</a>
          </li>

          <li v-if="data.type === 'NUMERIC'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'numeric'}"
               href="#"
               @click="activeTab = 'numeric'"
            >Nastavení čísla a jednotky</a>
          </li>

          <li v-if="systags.length > 0"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'systags'}"
               href="#"
               @click="activeTab = 'systags'"
            >Systémové funkce (tagy)</a>
          </li>

          <li v-if="data.type === 'BOOLEAN' || data.type === 'STATIC_STRING'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'default-static-value'}"
               href="#"
               @click="activeTab = 'default-static-value'"
            >Defaultní hodnota</a>
          </li>

          <li v-if="data.type === 'LONGTEXT'"
              class="nav-item"
          >
            <a class="nav-link"
               :class="{'active': activeTab == 'text-editor'}"
               href="#"
               @click="activeTab = 'text-editor'"
            >Textovy editor</a>
          </li>
        </ul>

        <DefaultValueForm v-if="activeTab == 'default-value'"
                          v-model="data.settings.default_value"
        ></DefaultValueForm>

        <template v-if="activeTab == 'multiple'">
          <div class="form-group">
            <label>Počet položek</label>
            <input v-model="data.multiple"
                   type="number"
                   class="form-control"
            >
            <div class="form-info-text">
              <span class="badge badge-pill badge-warning">Info</span>
              Pro neomezený počet položek zadejte hodnotu -1
            </div>
          </div>
        </template>

        <template v-if="activeTab == 'autocomplete'">
          <h5 class="card-title">
            Našeptávač
          </h5>
          <div class="form-group form-check">
            <input id="autocomplete-enabled"
                   v-model="data.settings.autocomplete.enabled"
                   type="checkbox"
                   class="form-check-input"
            >
            <label class="form-check-label"
                   for="autocomplete-enabled"
            >Aktivní</label>
          </div>
          <Grid
            v-if="data.settings.autocomplete.enabled"
            v-model="data.settings.autocomplete.options"
            :cols="cols"
            :options="{header: false}"
          >
          </Grid>
        </template>

        <template v-if="activeTab == 'link'">
          <h5 class="card-title">
            Typ linku
          </h5>
          <select v-model="data.settings.link.entity"
                  class="custom-select"
          >
            <option value="TASK">
              Úkol
            </option>
            <option value="PROJECT">
              Projekt
            </option>
          </select>
        </template>

        <template v-if="activeTab == 'enum'">
          <h5 class="card-title">
            Výběr z číselníku
          </h5>
          <select v-model="data.settings.enum.type"
                  class="custom-select"
                  style="margin: 10px auto"
          >
            <option value="manual">
              Ručně
            </option>
            <option value="flexibee_company">
              Flexibee adresář (automaticky)
            </option>
            <option value="flexibee_typ_zakazky">
              Flexibee typ zakázky (automaticky)
            </option>
          </select>
          <Grid
            v-if="data.settings.enum.type == 'manual'"
            v-model="data.settings.enum.list"
            :cols="cols"
            :options="{header: false}"
          >
          </Grid>
          <table v-else
                 class="table"
          >
            <tr v-for="(item, index) in data.settings.enum.list"
                :key="index"
            >
              <td>{{ item.text }}</td>
            </tr>
          </table>
        </template>

        <template v-if="activeTab == 'flexibee'">
          <h5 class="card-title">
            Flexibee
          </h5>
          <select v-model="data.settings.flexibee.type"
                  class="custom-select"
                  style="margin: 10px auto"
          >
            <option value="zakazka">
              Zakázka
            </option>
          </select>
          <table class="table">
            <tr v-for="(item, index) in data.settings.flexibee.list"
                :key="index"
            >
              <td>{{ item.id }}</td>
              <td>{{ item.text }}</td>
            </tr>
          </table>
        </template>

        <template v-if="activeTab == 'numeric'">
          <h5 class="card-title">
            Nastavení čísla a jednotky
          </h5>
          <div class="container">
            <div class="row">
              <div class="col">
                <div class="form-group form-check">
                  <input id="numeric-float"
                         v-model="data.settings.numeric.float"
                         type="checkbox"
                         class="form-check-input"
                  >
                  <label class="form-check-label"
                         for="numeric-float"
                  >Číslo může být desetinné</label>
                </div>
              </div>
              <div class="col">
                <div class="form-group form-check">
                  <input id="numeric-units"
                         v-model="data.settings.numeric.units"
                         type="checkbox"
                         class="form-check-input"
                  >
                  <label class="form-check-label"
                         for="numeric-units"
                  >Číslo má jednotky</label>
                </div>
              </div>
              <div class="col">
                <div class="form-group form-check">
                  <input id="numeric-convert"
                         v-model="data.settings.numeric.convertToDefault"
                         type="checkbox"
                         class="form-check-input"
                  >
                  <label class="form-check-label"
                         for="numeric-convert"
                  >Převést do výchozí jednotky</label>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label>Minimální hodnota</label>
                  <input v-model="data.settings.numeric.min"
                         type="text"
                         class="form-control"
                  >
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>Maximální hodnota</label>
                  <input v-model="data.settings.numeric.max"
                         type="text"
                         class="form-control"
                  >
                </div>
              </div>
              <div class="col">
                <div class="form-group">
                  <label>Krok hodnoty</label>
                  <input v-model="data.settings.numeric.step"
                         type="text"
                         class="form-control"
                  >
                </div>
              </div>
            </div>
          </div>
          <Grid
            v-if="data.settings.numeric.units"
            v-model="data.settings.numeric.unitsOptions"
            :cols="unitsCols"
            :options="{header: true}"
          >
          </Grid>
        </template>

        <template v-if="activeTab == 'validation'">
          <h5 class="card-title">
            Validace
          </h5>
          <div class="form-group form-check">
            <input id="required-field"
                   v-model="data.settings.validation.required"
                   type="checkbox"
                   class="form-check-input"
            >
            <label class="form-check-label"
                   for="required-field"
            >Hodnota musí být vyplněna</label>
          </div>
          <div class="form-group">
            <label>Regulární výraz</label>
            <input v-model="data.settings.validation.pattern"
                   type="text"
                   class="form-control"
            >
            <div class="form-info-text">
              <span class="badge badge-pill badge-warning">Info</span>
              Pro nastavení regulárního výrazu si přečtěte
              <a href="https://www.w3schools.com/tags/att_input_pattern.asp">oficiální dokumentaci</a>
            </div>
          </div>
          <div class="form-group">
            <label>Příklad/Nápověda pro regulární výraz</label>
            <input v-model="data.settings.validation.example"
                   type="text"
                   class="form-control"
            >
            <div class="form-info-text">
              <span class="badge badge-pill badge-warning">Info</span>
              Tento příklad či nápověda se zobrazí u chybové hlášky když uživatel vyplní políčko špatně.
            </div>
          </div>
        </template>

        <template v-if="activeTab == 'systags'">
          <h5 class="card-title">
            Systémové funkce (tagy)
          </h5>
          <div v-for="systag in systags"
               :key="systag.tag"
          >
            <div class="form-group form-check">
              <input id="exampleCheck1"
                     v-model="data.settings.systags[systag.tag]"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="exampleCheck1"
              >{{ systag.name }}</label>
              <div v-if="systag.help"
                   class="form-info-text"
              >
                <span class="badge badge-pill badge-warning">Info</span>
                {{ systag.help }}
              </div>
            </div>
          </div>
        </template>

        <template v-if="data.type === 'trigger'">
          <h5 class="card-title">
            Nastavení triggeru / externího volání
          </h5>
          <div class="form-group">
            <label for="triggerUrl">Url</label>
            <input id="triggerUrl"
                   v-model="data.url"
                   type="url"
                   class="form-control"
                   placeholder="https://api.somewhere"
            >
          </div>
          <div class="form-group">
            <label for="triggerMethod">Http metoda</label>
            <select id="triggerMethod"
                    v-model="data.method"
                    class="form-control"
            >
              <option v-for="o in httpMethods"
                      :key="o"
              >
                {{ o }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="triggerAuth">Autorizace</label>
            <input id="triggerAuth"
                   v-model="data.simpleAuth"
                   type="text"
                   class="form-control"
            >
          </div>
          <div class="form-group">
            <label for="triggerHeaders">Hlavicky</label>
            <VSelect id="triggerHeaders"
                     v-model="data.addHeaders"
                     taggable
                     multiple
            ></VSelect>
          </div>
          <div class="form-group">
            <label for="triggerPayload">Obsah (Payload)</label>
            <textarea id="triggerPayload"
                      v-model="data.payload"
                      class="form-control"
                      rows="10"
            ></textarea>
          </div>
          <hr />
        </template>

        <template v-if="data.type === 'enum'">
          <div class="form-group">
            <label for="triggerHeaders">Hodnoty</label>
            <VSelect id="triggerHeaders"
                     v-model="data.enum"
                     taggable
                     multiple
            ></VSelect>
          </div>
          <div class="form-info-text">
            <span class="badge badge-pill badge-warning">Info</span>
            Zadejte libovolné hodnoty, ze kterých pak bude možné vybírat.
          </div>
          <hr />
        </template>


        <template v-if="activeTab == 'auto-prefill'">
          <h5 class="card-title">
            Automatické předvyplnění vlastností
          </h5>
          <div>
            <div class="form-group form-check">
              <input id="auto-prefill-project"
                     v-model="data.defaultProject"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="auto-prefill-project"
              >Automaticky předvyplnit do projektu</label>
            </div>
            <div class="form-group form-check">
              <input id="auto-prefill-task"
                     v-model="data.defaultTask"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="auto-prefill-task"
              >Automaticky předvyplnit do úkolu</label>
            </div>
            <div class="form-group form-check">
              <input id="auto-prefill-resource"
                     v-model="data.defaultResource"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="auto-prefill-resource"
              >Automaticky předvyplnit do zdroje</label>
            </div>
          </div>
          <div class="form-info-text">
            <span class="badge badge-pill badge-warning">Info</span>
            Když budete zakládat nový typ projektu/úkolu/zdroje, tato vlastnost se vám automaticky přidá.
            Předvyplněná vlastnost se chová naprosto stejně jako ručně vytvořená vlastnost.
            Toto nastavení je pouze pro ušetření práce pokud používáte nějake vlastnosti často.
          </div>
        </template>

        <template v-if="activeTab == 'default-static-value'">
          <h5 class="card-title">
            Defaultni staticka hodnota
          </h5>
          <div>
            <div class="form-group form-check">
              <input id="default_static_value-enabled"
                     v-model="data.settings.default_static_value.enabled"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="default_static_value-enabled"
              >Aktivní</label>
            </div>
            <div class="form-group form-check">
              <input v-if="data.type === 'STATIC_STRING'"
                     id="defaultStaticValue"
                     v-model="data.settings.default_static_value.value"
                     value="projectsTable"
                     type="text"
                     class="form-check-input"
              >
              <input v-if="data.type === 'BOOLEAN'"
                     id="defaultStaticValue"
                     v-model="data.settings.default_static_value.value"
                     value="projectsTable"
                     type="checkbox"
                     class="form-check-input"
              >
              <label v-if="data.type === 'BOOLEAN'"
                     class="form-check-label"
                     for="defaultStaticValue"
              >Hodnota</label>
            </div>
          </div>
        </template>

        <template v-if="activeTab == 'show-in-table'">
          <h5 class="card-title">
            Nastavení zobrazování
          </h5>
          <div>
            <div class="form-group form-check">
              <input id="showInProjectsTable"
                     v-model="data.settings.visible"
                     value="projectsTable"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="showInProjectsTable"
              >Zobrazovat vlastnost v tabulkách projektů</label>
            </div>
            <div class="form-group form-check">
              <input id="showInTasksTable"
                     v-model="data.settings.visible"
                     value="tasksTable"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="showInTasksTable"
              >Zobrazovat vlastnost v tabulkách úkolů</label>
            </div>
            <div class="form-group form-check">
              <input id="showInResourcesTable"
                     v-model="data.settings.visible"
                     value="resourcesTable"
                     type="checkbox"
                     class="form-check-input"
              >
              <label class="form-check-label"
                     for="showInResourcesTable"
              >Zobrazovat vlastnost v tabulkách zdrojů</label>
            </div>
          </div>
        </template>

        <template v-if="activeTab == 'text-editor'">
          <h5 class="card-title">
            Textový editor
          </h5>
          <div>
            <Multiselect
              id="editor-type"
              v-model="data.settings.text_editor.type"
              :max="1"
              label="label"
              trackBy="id"
              valueByPath="id"
              :options="TEXT_EDITORS"
              :returnAsSingle="true"
              :allowEmpty="false"
            >
            </Multiselect>
            <!-- <div class="form-group">
              <label for="editorRows">Počet řádek editoru</label>
              <input id="editorRows" v-model="data.settings.text_editor.editor_rows"
                     type="number"
                     min="1"
                     class="form-control"
              >
            </div> -->
            <label for="data-type">Styl detailu</label>
            <Multiselect
              id="data-type"
              v-model="data.settings.text_editor.detail_style"
              :max="1"
              label="label"
              trackBy="id"
              valueByPath="id"
              :options="[{id: 'minimal', label: 'Minimální'}, {id: 'small', label: 'Malý náhled'}, {id: 'full', label: 'Kompletní text'}]"
              :allowEmpty="false"
              :returnAsSingle="true"
            >
            </Multiselect>
          </div>
        </template>

        <hr />

        <FormControls>
          <button v-if="isNew"
                  class="asd-btn-confirm"
                  @click="create(false)"
          >
            {{ $t('common.create') }}
          </button>
          <button v-if="!isNew && (data.activeUntil === null || data.activeUntil === 0)"
                  type="button"
                  class="asd-btn-delete"
                  @click="deactivateProperty"
          >
            Deaktivovat
          </button>
          <button v-else-if="!isNew"
                  type="button"
                  class="asd-btn-delete"
                  @click="activateProperty"
          >
            Reaktivovat
          </button>
          <button v-if="!isNew && (data.activeUntil === null || data.activeUntil === 0)"
                  type="button"
                  class="asd-btn-confirm"
                  @click="save"
          >
            {{ $t('common.save') }}
          </button>
        </FormControls>
      </div>
    </div>
  </div>
</template>

<script>
import LangFilters from 'CORE/mixins/langFilters'
import PropertyTypeMixin from 'CORE/mixins/property-type-data'
import _ from 'lodash'
import validate from 'uuid-validate'
import slugify from 'slugify'
import Grid from 'CORE/components/grid'
import DefaultValueForm from './settings/default-value'
import { NON_NEGATIVE_INT, SI_UNIT_SHORTCUT } from 'CORE/utils/regexp-lib.js'
import Multiselect from 'CORE/components/utilities/vue-multiselect-ext'
import FormControls from 'CORE/components/form/controls'

export default {
    name: 'PropertyTypeForm',
    components: {
        Grid,
        DefaultValueForm,
        Multiselect,
        FormControls,
    },
    mixins: [
        LangFilters,
        PropertyTypeMixin,
    ],
    data: function() {
        return {
            data: {},
            activeTab: 'auto-prefill',
        }
    },
    computed: {
        propertyTypeId() {
            return this.$route.params.id
        },
        dataTypes() {
            return _.map(this.$store.getters.dataTypes, t => {
                return {
                    id: t.id,
                    label: this.$t(`property-type.types.${t.id}`),
                }
            })
        },
        httpMethods() {
            return ['GET', 'HEAD', 'POST', 'PUT', 'DELETE', 'CONNECT', 'OPTIONS', 'TRACE']
        },
        isNew() {
            return !validate(this.propertyTypeId)
        },
        systags() {
            return this.$store.getters.systagsByDataType(this.data.type)
        },
        cols() {
            return {
                text: {
                    required: true,
                },
            }
        },
        unitsCols() {
            return {
                name: {
                    name: 'Jednotka',
                    required: true,
                },
                shortcut: {
                    name: 'Zkratka',
                    pattern: SI_UNIT_SHORTCUT,
                    required: true,
                },
                multiplier: {
                    name: 'Násobitel',
                    pattern: NON_NEGATIVE_INT,
                    required: true,
                    defaultValue: 1,
                },
                default: {
                    name: 'Výchozí',
                    type: 'checkbox',
                    unique: true,
                    defaultValue: false,
                },
            }
        },
        entityStates() {
            const es = _.get(this.$store.getters.currentUser, 'company.settings.entity-states', [])
            return _.map(es, (s, key) => {
                return {
                    id: key,
                    label: _.get(s, 'name', `<missing_name> ID: ${key}`),
                }
            })
        },
        TEXT_EDITORS() {
            return [
                {
                    id: 'plaintext',
                    label: 'Plaintext',
                },
                {
                    id: 'markdown',
                    label: 'Markdown',
                },
            ]
        },
    },
    async mounted() {
        if (!this.isNew) {
            if (_.isObject(this.propertyType)) {
                this.data = this.addDefaultData(_.cloneDeep(this.propertyType))
            } else {
                this.data = this.addDefaultData({})
                const unsubscribe = this.$store.subscribe(({ type, payload }) => {
                    if (type === 'setPropertyTypes') {
                        this.data = this.addDefaultData(_.cloneDeep(this.propertyType))
                        unsubscribe()
                    }
                })
            }
        } else {
            this.data = this.addDefaultData({})
        }
    },
    methods: {
        async deactivateProperty() {
            this.data.activeUntil = parseInt(Date.now() / 1000)
            await this.$store.dispatch('updatePropertyType', this.data)
            await this.$store.dispatch('propertyTypesLoad')
            this.flash('Vlastnost byla deaktivovana', 'success', {
                timeout: 1500,
            })
            this.$router.push({ name: 'propertyTypeList' })
        },
        async activateProperty() {
            this.data.activeUntil = null
            await this.$store.dispatch('updatePropertyType', this.data)
            await this.$store.dispatch('propertyTypesLoad')
            this.flash('Vlastnost byla znovu aktivovana', 'success', {
                timeout: 1500,
            })
        },
        addDefaultData(currentData = {}) {
            const defaultData = {
                id: this.$uuid.v4(),
                name: '',
                settings: {
                    systags: {},
                    visible: [],
                    order: 0,
                    autocomplete: {
                        enabled: false,
                        options: [],
                    },
                    validation: {},
                    numeric: {
                        float: false,
                        units: false,
                    },
                    enum: {
                        type: 'manual',
                        list: [],
                    },
                    link: {
                        entity: 'TASK',
                    },
                    flexibee: {
                        type: 'zakazka',
                        list: [],
                    },
                    default_value: {
                        enabled: false,
                        chunks: [],
                        only_empty: false,
                        type: 'default',
                    },
                    text_editor: {
                        type: 'plaintext',
                        editor_rows: 1,
                        detail_style: 'minimal',
                    },
                    entity_state: {
                        graph: undefined,
                    },
                },
            }
            _.defaultsDeep(currentData, defaultData)
            if (!_.isPlainObject(currentData.settings)) {
                currentData.settings = {}
            }
            if (!_.isPlainObject(currentData.settings.systags)) {
                currentData.settings.systags = {}
            }
            if (!_.isArray(currentData.settings.visible)) {
                currentData.settings.visible = []
            }
            if (!_.isPlainObject(currentData.settings.autocomplete)) {
                currentData.settings.autocomplete = {
                    enabled: false,
                    options: [],
                }
            }
            if (!_.get(currentData, 'settings.order', false)) {
                currentData.settings.order = 0
            }
            if (!_.isPlainObject(currentData.settings.autocomplete)) {
                currentData.settings.autocomplete = {}
            }
            if (!_.isPlainObject(currentData.settings.validation)) {
                currentData.settings.validation = {}
            }
            if (!_.isPlainObject(currentData.settings.enum)) {
                currentData.settings.enum = {
                    type: 'manual',
                    list: [],
                }
            }
            if (!_.isPlainObject(currentData.settings.flexibee)) {
                currentData.settings.flexibee = {
                    type: 'zakazka',
                    list: [],
                }
            }
            if (!_.isPlainObject(currentData.settings.default_value)) {
                currentData.settings.default_value = {
                    enabled: false,
                    chunks: [],
                    only_empty: false,
                }
            }
            if (!_.isPlainObject(currentData.settings.default_static_value)) {
                currentData.settings.default_static_value = {
                    enabled: false,
                    value: null,
                }
            }
            return currentData
        },
        async save() {
            try {
                this.data.multiple = _.toNumber(this.data.multiple)
                await this.$store.dispatch('updatePropertyType', this.data)
                await this.$store.dispatch('propertyTypesLoad')
                this.flash('Uloženo', 'success', {
                    timeout: 3000,
                })
                this.$router.push('/property-type/list')
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
        async create(andNew) {
            const data = this.data
            _.set(data, 'key', `company-${slugify(_.lowerCase(data.name))}`)
            _.set(data, 'settings.systags', _.pickBy(data.settings.systags, (assigned, tag) => {
                if (assigned && _.size(_.filter(this.systags, t => t.tag === tag))) {
                    return true
                }
                return false
            }))
            _.set(data, 'timeProportional', true)
            try {
                _.set(data, 'settings.order', this.$store.getters.propertyTypes.length + 1)
            } catch (e) {
                this.flash(`Nastala nekriticka chyba [${e.message}]`, 'warning')
                _.set(data, 'settings.order', 0)
            }

            try {
                this.data.multiple = _.toNumber(this.data.multiple)
                await this.$store.dispatch('createPropertyType', data)
                await this.$store.dispatch('propertyTypesLoad')
                this.flash('Vytvořeno', 'success', {
                    timeout: 3000,
                })
                this.data = {}
                if (!andNew) {
                    this.$router.push('/property-type/list')
                }
            } catch (e) {
                this.flash(`Nepovedlo se [${e.message}]`, 'error')
                throw e
            }
        },
    },
}
</script>

<style scoped>
.form-info-text {
    color: silver;
    padding: 5px 5px 0px 20px;
}
.card-title {
    margin: 20px 0 5px 0;
    font-size: 1rem;
    text-align: center;
}
.property-settings {
    margin-top: 20px;
}
label.required::after {
    content: "*";
    margin: 0px auto 0px 5px;
    color: var(--danger);
}
input[type="checkbox"]:checked + label {
    font-weight: bold;
}
.nav-link:hover {
    color: #000 !important;
}
.inactive-info-text {
    text-align: center;
    font-size: 2rem;
    color: firebrick;
    margin: 20px;
}
</style>
